import React from "react";
import moment from 'moment';
import "./Order.css";

class PrintOrderSheetForBox extends React.Component {
    render() {
        const { generateData, info, refillStartDate, refillDuration, refillLength } = this.props;

        if (!generateData || generateData.length < 3) return null;

        const times = generateData[0];
        const directions = generateData[1];
        const medicines = generateData[2];

        const keys = Object.keys(medicines); // ['key1', 'key2', 'key3']

        return (
            <div id="print-content-box">
                <div className="contentHeader">
                    <p style={{ color: 'black', marginBottom: '0px' }}>
                        Patient Name - {info && info.user ? `${info.user.first_name} ${info.user.last_name}` : ''}
                        {refillLength > 1 ? ' (Repeat)' : ' (New)'}
                    </p>
                    <p style={{ color: 'black', marginBottom: '0px' }}>
                        Start Date - {moment(refillStartDate).format('DD-MM-YYYY')} ({moment(refillStartDate).format('dddd')})
                    </p>
                    <p style={{ color: 'black', marginBottom: '10px' }}>
                        Refill Cycle Tenure - {refillDuration} Days
                    </p>
                </div>
                <table className="tableStyle">
                    <thead>
                        <tr>
                            <th className="medicineCell">Medicine Name</th>
                            <th className="doseCell">Dose Info</th>
                        </tr>
                    </thead>
                    <tbody>
                        {keys.map((key, index) => {
                            return (
                                <tr key={key}>
                                    <td className="medicineCell">
                                        <div dangerouslySetInnerHTML={{ __html: medicines[key] }} />
                                    </td>

                                    <td className="doseCell">
                                        <div>Dose {index + 1}</div>
                                        <div>{times[key]}</div>
                                        <div>{directions[key]}</div>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default PrintOrderSheetForBox;


// WEBPACK FOOTER //
// ./src/component/FetchOrderList/PrintOrderSheetForBox.js